export default "__VITE_ASSET__BfiLmJ24__"